import {useRef} from "react"
import Text from "../../components/input/text";
import Textarea from "../../components/input/textarea";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {email_content, journey_info} from "../../config/tips";
import Select from "../../components/input/select";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import {Cpu, Info, Shield} from "react-feather";
import TabLabel from "../../components/tabLabel";
import Number from "../../components/input/number";
import {Enums} from "../../config/Config";
import {useNavigate} from "react-router-dom";

const Form = (props) => {
    const {journey, audiences, errors, isReady, onSubmit} = props

    const formRef = useRef()
    const navigate = useNavigate()
    const infoTab = <TabLabel slug="info" label="Info" icon={<Info/>} errors={errors}/>
    const limitsTab = <TabLabel slug="limits" label="Limits" icon={<Shield/>} errors={errors}/>
    const builderTab = <TabLabel slug="builder" label="Builder" icon={<Cpu/>} errors={errors}/>


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            info  : {
                title      : FormData.get('title'),
                status     : FormData.get('status'),
                id_audience: FormData.get('id_audience'),
                description: FormData.get('description'),
            },
            limits: {
                daily_ws_limit   : FormData.get('daily_ws_limit'),
                daily_sms_limit  : FormData.get('daily_sms_limit'),
                daily_email_limit: FormData.get('daily_email_limit'),
            }
        })
    }


    const handleTabClick = (ev) => {
        if (ev === 'builder') {
            navigate(`/journeys/${journey?._id?.$oid}/builder`)
        }
    }




    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <Tabs defaultActiveKey="0" onTabClick={handleTabClick}>
                <TabPane forceRender={true} key={'info'} tabKey={'info'} tab={infoTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/journeys"
                        message={journey_info}
                    />


                    <Text required
                        size="md"
                        name="title"
                        label="Title"
                        isReady={isReady}
                        value={journey?.title}
                        disabled={journey?.status === 'sent'}
                        placeholder="Type journey title..."
                        error={errors && errors['info.title']}
                    />

                    <Select required
                        size="md"
                        isReady={isReady}
                        label="Audience"
                        name="id_audience"
                        options={audiences}
                        placeholder="Choose an audience"
                        value={journey?.id_audience?.$oid}
                        isDisabled={journey?.status === 'sent'}
                        error={errors && errors['info.id_audience']}
                    />

                    {journey?.status !== 'sent' && <Select required
                        size="md"
                        name="status"
                        label="Status"
                        isReady={isReady}
                        value={journey?.status}
                        placeholder="Choose a status"
                        options={Enums.status.journey}
                        error={errors && errors['info.status']}
                    />}


                    <Textarea
                        size="md"
                        isReady={isReady}
                        name="description"
                        label="Description"
                        value={journey?.description}
                        disabled={journey?.status === 'sent'}
                        placeholder="Type a short description..."
                        error={errors && errors['info.description']}
                    />

                </TabPane>
                <TabPane forceRender={true} key={'limits'} tabKey={'limits'} tab={limitsTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/email"
                        message={email_content}
                    />

                    <Number
                        size="md"
                        isReady={isReady}
                        name="daily_sms_limit"
                        label="Daily sms limit"
                        placeholder="Set daily submits limit"
                        disabled={journey?.status === 'sent'}
                        value={journey?.limits?.daily_sms_limit}
                        error={errors && errors['limit.daily_sms_limit']}
                    />

                    <Number
                        size="md"
                        isReady={isReady}
                        name="daily_email_limit"
                        label="Daily email limit"
                        placeholder="Set daily submits limit"
                        disabled={journey?.status === 'sent'}
                        value={journey?.limits?.daily_email_limit}
                        error={errors && errors['limit.daily_email_limit']}
                    />

                    <div className="d-none">
                        <Number
                            size="md"
                            isReady={isReady}
                            name="daily_ws_limit"
                            label="Daily ws limit"
                            placeholder="Set daily submits limit"
                            disabled={journey?.status === 'sent'}
                            value={journey?.limits?.daily_ws_limit}
                            error={errors && errors['limit.daily_ws_limit']}
                        />
                    </div>

                </TabPane>
                {journey && <TabPane forceRender={false} key={'builder'} tabKey={'builder'} tab={builderTab}>
                    Builder
                </TabPane>}
            </Tabs>

            {journey?.status !== 'sent' && <Button
                size="sm"
                color="primary"
                isReady={isReady}
                icon={journey ? 'check' : 'plus'}
                label={journey ? 'Update' : 'Create'}
            />}


        </form>
    )
}

export default Form